interface CoachingSessionPresentationInput {
  simulation_agents?: { name?: string | null } | null;
  coaching_templates?: { category?: string | null } | null;
}

export function getCoachingSessionTitle(session: CoachingSessionPresentationInput): string {
  return session.simulation_agents?.name?.trim() || 'Coaching Session';
}

export function getCoachingSessionSubtitle(session: CoachingSessionPresentationInput): string {
  const category = session.coaching_templates?.category?.trim();
  return category ? `${category} coaching` : 'Coaching session';
}
